import React from 'react';
import PropTypes from 'prop-types';
import pickBy from 'lodash/pickBy';
import Button from '../Button';
import Toggle from '../Toggle';
import SubscriptionPlans from '../SubscriptionPlans';
import { H3, P1 } from '../Typography';

class Plans extends React.PureComponent {
  static propTypes = {
    activePlan: PropTypes.object,
    chosenPlan: PropTypes.object,
    onChangePlan: PropTypes.func,
    onConfirmPlan: PropTypes.func,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      formEnabled: true,
    };
  }

  onToggleAnnual = newValue => {
    this.setState({ fetching: true, formEnabled: false });
    this.props
      .onChangePlan({
        name: this.props.chosenPlan.name,
        annual: newValue,
      })
      .then(() => this.setState({ fetching: false, formEnabled: true }))
      .catch(() => this.setState({ fetching: false, formEnabled: true }));
  };

  onTogglePlan = name => {
    this.setState({ fetching: true, formEnabled: false });
    this.props
      .onChangePlan({
        name: name,
        annual: this.props.chosenPlan.annual,
      })
      .then(() => this.setState({ fetching: false, formEnabled: true }))
      .catch(() => this.setState({ fetching: false, formEnabled: true }));
  };

  onDoConfirmPlan = plan => {
    if (!this.state.formEnabled) {
      return;
    }

    if (
      this.props.chosenPlan.name === undefined ||
      this.props.chosenPlan.annual === undefined
    ) {
      return;
    }

    this.setState({ fetching: true, formEnabled: false });
    this.props
      .onConfirmPlan(plan)
      .then(() => this.setState({ fetching: false }))
      .catch(() => this.setState({ fetching: false, formEnabled: true }));
  };

  render() {
    const {
      activePlan,
      chosenPlan,
      onChangePlan,
      onConfirmPlan,
      ...otherProps
    } = this.props;

    const mergedPlans = {
      ...activePlan,
      ...pickBy(chosenPlan, v => v !== undefined),
    };

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '3rem 3rem 0',
            alignItems: 'center',
          }}
        >
          <span style={{ minWidth: '12.5rem' }}>
            Paying {mergedPlans.annual ? 'Annually' : 'Monthly'}{' '}
          </span>
          <Toggle checked={mergedPlans.annual} onToggle={this.onToggleAnnual} />
        </div>

        <div
          style={{
            padding: '2rem 6.5rem 6rem 5.5rem',
          }}
        >
          <H3>Now, choose your subscription</H3>
          <P1 style={{ marginBottom: '2rem' }}>
            Upgrade, downgrade, or cancel anytime.
          </P1>
          <SubscriptionPlans
            plan={mergedPlans}
            onSelectPlan={this.onTogglePlan}
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '5.5rem',
            }}
          >
            <Button
              arrow={true}
              onClick={this.onDoConfirmPlan}
              working={this.state.fetching}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Plans;



// WEBPACK FOOTER //
// ./src/components/Plans/Plans.js